import { Component, Inject, OnInit } from '@angular/core';
import { appSettings } from '../../../../modules/shared/components/appSettings';
import { AppSettings } from '../../../../entities/AppSettings';
import { ApiService } from '../../../../services/api/api.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lookup-value-import',
  templateUrl: './lookup-value-import.component.html',
  styleUrls: ['./lookup-value-import.component.css']
})
export class LookupValueImportComponent implements OnInit {

  private lookupValueGroupId: any;
  public loading: boolean = false;
  public canSubmitImport: boolean;
  public uploadedFilename: any;
  public validationsLoaded: boolean;
  public validations: any;
  public appSettings: AppSettings = appSettings;
  constructor(@Inject(MAT_DIALOG_DATA) public config: any, public ref: MatDialogRef<LookupValueImportComponent>, 
    private apiService: ApiService,
    private messageService?: ToastrService) {
    if (config && config && config.lookupValueGroupId) {
      this.lookupValueGroupId = config.lookupValueGroupId;
    }



  }

  ngOnInit() {
  }

  downloadTemplate() {
    //const link = document.createElement('a');
    //link.href = `${appSettings.apiServiceAddress}/api/requisitionItem/reqImportTemplates/ReqItemImport.xlsx`;
    //link.setAttribute('visibility', 'hidden');
    //link.click();

    this.apiService.downloadFile(`${appSettings.apiServiceAddress}/api/Lookupvalue/Template`)
      .subscribe(respData => {
        var blob = new Blob([respData]);
        this.apiService.saveFile(blob, 'Import.xlsx');
      }, error => {
        console.log('err');
      });
  }

  onBeforeSend(event) {
    var errors = new Array();
    this.loading = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }

  onProgress(event) {
  }

  onUploadError(event) {
    this.messageService.error("Could not upload file", "Action");
    this.canSubmitImport = false;
    this.loading = false;
  }

  onBasicUploadAuto(data) {
    this.messageService.success("Uploaded file", "Action");
    this.uploadedFilename = data.originalEvent.body.filename;
    this.validateFileData();
    this.canSubmitImport = false;
  }

  validateFileData() {
    this.messageService.info("Validation of file started", "Action");
    this.validationsLoaded = false;
    this.loading = true;
    this.apiService.get(`/api/lookupValueGroup/validateImport/${this.lookupValueGroupId}/${this.uploadedFilename}`)
      .subscribe(validations => {
        this.validations = validations;
        this.messageService.success("File validated", "Action");
        this.loading = false;
        this.canSubmitImport = this.validations.filter(o => o.error).length == 0;
        this.validationsLoaded = true;
      }, error => {
        this.messageService.error("Could not validate file", "Action");
        this.loading = false;
      });
  }

  importData() {
    this.loading = true;
    this.apiService.get(`/api/lookupValueGroup/importData/${this.lookupValueGroupId}/${this.uploadedFilename}`)
      .subscribe(validations => {
        this.validations = validations;
        this.messageService.success("File imported", "Action");
        this.loading = false;
        this.canSubmitImport = false;
        this.validationsLoaded = false;
        this.ref.close(true);
      }, error => {
        this.messageService.error("Could not import file", "Action");
        this.loading = false;
      });
  }
}
